import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogActions, DialogContent, DialogContentText, DialogTitle, Button, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Solvent } from "pages/statuses/Solvent";
import { Solvent as SolventEntity } from "api/entities/Solvent";
import { SolventApi } from "api/SolventApi";
import * as CommonConstants from "utilities/CommonConstants";

const useStyles = makeStyles((theme: Theme) => ({
    takeOut: {
        color: CommonConstants.BOOKING_TYPE_COLOR_TAKEOUT,
        fontSize: `30px`,
    },
    pompOut1: {
        color: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT1,
        fontSize: `30px`,
    },
    pompOut2: {
        color: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT2,
        fontSize: `30px`,
    },
    closeButton: {
        position: `absolute`,
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    contact: {
        // textAlign: `right`,
    },
}));

interface Props {
    isOpen: boolean;
    onClickClose: VoidFunction;
}

/**
 * 予約種別ごとの溶媒リスト表示ダイアログ
 * @param props
 */
export const ContactDialog: React.FC<Props> = (props) => {
    const { isOpen, onClickClose } = props;
    const classes = useStyles();
    const [solvents, setSolvents] = useState<Solvent[]>([]); // 溶媒マスタ

    useEffect(() => {
        const execute = async () => {
            // 溶媒マスタ取得
            let result;
            result = await SolventApi.getSolventForInfo();
            console.log(result);
            if (result?.status === 200) {
                const solventEntities: SolventEntity[] = Array.from(result?.data.solvents);
                const solvents: Solvent[] = Array.from(solventEntities);
                setSolvents(solvents);
            }
        };
        execute();
    }, []);

    const body = (
        <div>
            <h5>
                <span className={classes.takeOut}>● </span>
                環境安全センターⅡ
            </h5>
            <h5 className={classes.contact}>　　　内線番号：5817</h5>
        </div>
    );
    const descriptionElementRef = React.useRef<HTMLElement>(null);

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={onClickClose}
                scroll="paper"
                fullWidth={true}
                maxWidth="xs"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClickClose}>
                    <CloseIcon />
                </IconButton>
                <DialogTitle id="scroll-dialog-title">問い合わせ先</DialogTitle>
                <DialogContent dividers={true}>
                    <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                        {body}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClickClose} color="primary">閉じる</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
